// extracted by mini-css-extract-plugin
export default {"customRangeFilter":"styles_customRangeFilter__G1-TB"};